<template>
	<div class="bg-white px-3 index">
		<div class="add_tits" ref="title">
			<el-form class="form-inlines" :inline="true">
				<el-form-item label="姓名:">
					<el-input v-model="formData.keyword" placeholder="请输入内容" size="small"></el-input>
				</el-form-item>

				<el-form-item label="类型:">
					<el-select v-model="formData.qdname" placeholder="请选择" size="small" filterable clearable>
						<el-option label="中医" value="1"></el-option>
						<el-option label="西医" value="2"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="small" @click="add">添加</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="ibox-content" v-loading="dcing">
			<!-- <div class="b_top u-f u-jsb">
				<el-button icon="el-icon-printer" :loading='dcing' size="mini" @click="exportExcel">
					导出Excel</el-button>
			</div> -->
			<el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable"
				 :row-key="getRowKeys">
				<el-table-column prop="id" label="ID" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="user_id" label="医生ID" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="create_time" label="申请入驻日期" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="addressee" label="用户属性" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="real_name" label="真实姓名" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="phone" label="手机号" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="identity_card" label="身份证号" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="hospital_id_text" label="医院" show-overflow-tooltip></el-table-column>
				<el-table-column prop="address" label="地区" show-overflow-tooltip>
					<template slot-scope="scope">
						<template v-if="scope.row.hospital">
							{{scope.row.hospital.province_code_text}}-{{scope.row.hospital.city_code_text}}-{{scope.row.hospital.area_code_text}}
						</template>
					</template>
				</el-table-column>
				<el-table-column prop="competent_id_text" label="职称" show-overflow-tooltip></el-table-column>
				<el-table-column prop="department_id_text" label="科室" show-overflow-tooltip></el-table-column>
				<el-table-column prop="certificate_code" label="执业证书编码" show-overflow-tooltip></el-table-column>
				<el-table-column prop="examine_text" label="审核状态" show-overflow-tooltip></el-table-column>
				<el-table-column prop="examine_time" label="入驻日期" show-overflow-tooltip></el-table-column>
				<el-table-column prop="source_str" label="渠道来源" show-overflow-tooltip></el-table-column>
				<el-table-column prop="inviter_nickname" label="邀请人" show-overflow-tooltip></el-table-column>
				<el-table-column label="操作" align="center" width="120" fixed="right">
					<template slot-scope="{row,$index}">
						<el-button size="mini" type="text" @click="handleEdit($index, row)">详情
						</el-button>
						<el-dropdown trigger="click" style="margin-left:10px">
							<span class="el-dropdown-link">
								更多<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item><span @click="deleteHandle('home', row)">删除</span>
								</el-dropdown-item>

							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>
			</el-table>
			<div class="u-f u-ac u-jsb ft_mr">
				<div></div>
				<div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper" :total="count">
					</el-pagination>
				</div>
			</div>

		</div>

		<div v-show="false">
			<el-table :data="tableData2" border v-loading="loading" :height="heights" id="out-table">
				<el-table-column prop="create_time" label="申请入驻日期" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="addressee" label="用户属性" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="real_name" label="真实姓名" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="phone" label="手机号" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="identity_card" label="身份证号" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="hospital_id_text" label="医院" show-overflow-tooltip></el-table-column>
				<el-table-column prop="address" label="地区" show-overflow-tooltip>
					<template slot-scope="scope">
						<span
							v-if="scope.row.hospital">{{scope.row.hospital.province_code_text}}-{{scope.row.hospital.city_code_text}}-{{scope.row.hospital.area_code_text}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="competent_id_text" label="职称" show-overflow-tooltip></el-table-column>
				<el-table-column prop="department_id_text" label="科室" show-overflow-tooltip></el-table-column>
				<el-table-column prop="certificate_code" label="执业证书编码" show-overflow-tooltip></el-table-column>
				<el-table-column prop="examine_text" label="审核状态" show-overflow-tooltip></el-table-column>
				<el-table-column prop="examine_time" label="入驻日期" show-overflow-tooltip></el-table-column>
				<el-table-column prop="source_str" label="渠道来源" show-overflow-tooltip></el-table-column>
				<el-table-column prop="inviter_nickname" label="邀请人" show-overflow-tooltip></el-table-column>

			</el-table>
		</div>
		<!--详情  -->
		<el-dialog title="详情" :visible.sync="dialog_info" width="80%" center top="5vh">
			<div class="dialog-ibox-content">
				<el-form ref="formed" :model="formed" label-width="140px" :rules="rule" class="forms-inlines">

				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialog_info = false" size="small">确 认</el-button>
			</span>
		</el-dialog>
		<!-- 添加 -->
		<el-dialog title="添加" :visible.sync="dialog_add" center top="100px" width="60%" class="dialogs">
			<el-divider></el-divider>
			<div class="dialog-ibox-content">
				<el-form ref="formed" :model="addformdata" label-width="100px" :rules="rule">
					<el-form-item label="类型:">
						<el-radio-group v-model="addformdata.type">
							<el-radio :label="1">中医</el-radio>
							<el-radio :label="2">西医</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="选择医生:">
						<div class="u-f">
							<div style="width:50%">
								<el-table :data="userTableData" border height="490px" ref="configurationTables"
									@selection-change="handleSelectionChange" :row-key="getRowKeys">
									<el-table-column type="selection" width="55" :reserve-selection="true" />
									<el-table-column prop="title" label="头像" show-overflow-tooltip>
										<template slot-scope="scope">
											<el-image style="width: 50px; height: 50px;border-radius:50%"
												v-if="scope.row.head_portrait_pic&&scope.row.head_portrait_pic.length>0"
												:src="scope.row.head_portrait_pic[0].url" fit="cover">
											</el-image>
										</template>
									</el-table-column>
									<el-table-column prop="live_broadcast" label="用户名" show-overflow-tooltip>
										<template slot-scope="scope">
											<span>{{scope.row.real_name}}</span>
										</template>
									</el-table-column>
									<el-table-column prop="competent_id_text" label="职称" show-overflow-tooltip>
									</el-table-column>
									<el-table-column prop="department_id_text" label="科室" show-overflow-tooltip>
									</el-table-column>
								</el-table>
							</div>
							<div style="width:50%;margin-left:10px">
								<el-table :data="selectusers" border height="490px" ref="configurationTable">
									<el-table-column prop="title" label="头像" show-overflow-tooltip>
										<template slot-scope="scope">
											<el-image style="width: 50px; height: 50px;border-radius:50%"
												v-if="scope.row.head_portrait_pic&&scope.row.head_portrait_pic.length>0"
												:src="scope.row.head_portrait_pic[0].url" fit="cover">
											</el-image>
										</template>
									</el-table-column>
									<el-table-column prop="live_broadcast" label="用户名" show-overflow-tooltip>
										<template slot-scope="scope">
											<span>{{scope.row.real_name}}</span>
										</template>
									</el-table-column>
									<el-table-column prop="competent_id_text" label="职称" show-overflow-tooltip>
									</el-table-column>
									<el-table-column prop="department_id_text" label="科室" show-overflow-tooltip>
									</el-table-column>
								</el-table>
							</div>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="addSubmit('formed')" size="small">确 定</el-button>
				<el-button @click="dialog_info = false" size="small">取 消</el-button>
			</span>
		</el-dialog>

	</div>
</template>


<script>
	import {
		mapState
	} from 'vuex'
	import invitable from "../../../components/settle/table";
	export default {
		components: {
			invitable
		},
		data() {
			return {
				formData: {
					time: '',
					hosname: '',
					hos_options: [],
					province: '',
					pro_options: [],
					city: '',
					city_options: [],
					jobname: '',
					job_options: [],
					ksname: '',
					ks_options: [],
					qdname: '',
					qd_options: [],
					yqrname: '',
					yq_options: [],
					keyword: '',
				},
				loading: false,
				dcing: false,
				tableData: [],
				tableData2: [],
				currentPage: 1,
				pagesize: 15,
				count: 0,
				heights: null,
				formed: {
					department: [],
					doctitle: [],
					hospital: "",
					email: "",
					userId: "",
					phone: "",
					username: "",
					goodat: "",
					brief: "",
					zc_mapList: [],
					zg_mapList: [],
					zyzs_mapList: [],
					id_mapList: [],
					tx_mapList: [],
					doneuser: "",
					servicenum: "",
					goodnum: "",
					new_hospital: "",
					tw_mon: 0,
					yy_mon: 0,
					sp_mon: 0,
					doctor_inquiry_url: '',
				},
				rule: {
					result: [{
						required: true,
						message: "请填写拒绝通过的理由",
						trigger: "blur",
					}, ],
					department: [{
						required: true,
						message: "请选择科室",
						trigger: "blur",
					}, ],
					doctitle: [{
						required: true,
						message: "请选择职称",
						trigger: "blur",
					}, ],
					hospital: [{
						required: true,
						message: "请选择医院",
						trigger: "blur",
					}, ],

					userId: [{
						required: true,
						message: "请填写身份证号码",
						trigger: "blur",
					}, ],
					phone: [{
						required: true,
						message: "请填写手机号码",
						trigger: "blur",
					}, ],
					username: [{
						required: true,
						message: "请填写真实姓名",
						trigger: "blur",
					}, ],
					goodat: [{
						required: true,
						message: "请填写擅长",
						trigger: "blur",
					}, ],
					brief: [{
						required: true,
						message: "请填写简介",
						trigger: "blur",
					}, ],

					zg_mapList: [{
						required: true,
						message: "请添加资格证书",
						trigger: "blur",
					}, ],
					zyzs_mapList: [{
						required: true,
						message: "请添加职业证书",
						trigger: "blur",
					}, ],
					id_mapList: [{
						required: true,
						message: "请添加身份证照片",
						trigger: "blur",
					}, ],
					tx_mapList: [{
						required: true,
						message: "请添加头像",
						trigger: "blur",
					}, ],
					doneuser: [{
						required: true,
						message: "请输入完成用户名",
						trigger: "blur",
					}, ],
					servicenum: [{
						required: true,
						message: "请输入服务数量",
						trigger: "blur",
					}, ],
					goodnum: [{
						required: true,
						message: "请输入好评率",
						trigger: "blur",
					}, ],
					tw_mon: [{
						required: true,
						message: "请设置图文咨询费用",
						trigger: "blur",
					}, ],
					yy_mon: [{
						required: true,
						message: "请设置语音咨询费用",
						trigger: "blur",
					}, ],
					sp_mon: [{
						required: true,
						message: "请设置视频咨询费用",
						trigger: "blur",
					}, ],
				},
				mapListed: [],
				mapListed2: [],
				mapListed3: [],
				mapListed4: [],
				mapListed5: [],
				eid: "",
				dialog_info: false,
				userid: "",
				userinfoid: "",
				doctitids: "",
				doctitid: "",
				departids: "",
				departid: "",
				source: 1,
				depat_options: [],
				doctitle_options: [],
				hos_options: [],
				dialog_invite: false,
				invitindex: 0,
				doc_id: "",
				bdcode: "",
				dialogCode: false,
				multipleSelection: [],
				ewmText: '报到二维码',
				ewmloading: false,




				dialog_add: false, //添加弹窗
				userTableData: [],
				selectusers: [],
				addformdata:{
					type:1
				}

			};
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			})
		},
		mounted() {
			let that = this
			that.getall()
			that.getHeight()
			that.begin()
			this.doc_search()
		},
		methods: {
			// 获取高度
			getHeight() {
				let that = this;
				var title = that.$refs.title.offsetHeight
				that.heights = window.innerHeight - title - 220 + 'px'
				window.onresize = () => {
					var title = that.$refs.title.offsetHeight
					that.heights = window.innerHeight - title - 220 + 'px'
				}
			},
			begin() {
				let that = this
				that.currentPage = 1
				that.pagesize = 15
				that.search()
			},
			search() {
				let that = this
				that.loading = true
				axios
					.post("/admin/DoctorAudit/doctorDetailReport", {
						page: that.currentPage,
						page_count: that.pagesize,

					}, {
						token: true
					})
					.then(response => {
						that.loading = false
						that.tableData = response.data.data.list
						that.count = response.data.data.totalCount
					})
					.catch(error => {})
			},
			add() {
				this.dialog_add = true
			},
			doc_search() {
				let that = this
				axios
					.post("/admin/dictionaryQuestion/doctorList", {
						keyword: '',
						department_id: '',
						competent_id: ''
					}, {
						token: true
					})
					.then(response => {
						that.userTableData = response.data.data
					})
					.catch(error => {})
			},

			handleEdit(index, row) {
				let that = this;
				this.eid = row.id;
				this.source = row.source;
				this.userid = row.user_id;
				this.userinfoid = row.user_info_id;
				this.examine = row.examine;

				this.jbxxItem = "";
				axios
					.post(
						"/admin/doctorAudit/readExamine", {
							id: that.eid,
							source: row.source
						}, {
							token: true,
						}
					)
					.then((response) => {
						var data = response.data.data;
						if (data) {
							// that.form.examine = data.examine
							// that.form.result = data.examine == '1' ? '' : data.examine_result
						} else {
							that.eid = "";
						}
						that.formed.tx_mapList = data.head_portrait_pic;
						that.mapListed = data.head_portrait_pic;
						that.formed.id_mapList = data.identity_card_pic;
						that.mapListed2 = data.identity_card_pic;
						that.formed.zyzs_mapList = data.physician_card_pic;
						that.mapListed3 = data.physician_card_pic;
						that.formed.zg_mapList = data.physician_seniority_pic;
						that.mapListed4 = data.physician_seniority_pic;
						that.formed.zc_mapList = data.competent_certificate_pic;
						that.mapListed5 = data.competent_certificate_pic;

						that.formed.goodat = data.good_at;
						that.formed.brief = data.introduction;

						that.formed.goodnum = data.praise;
						that.formed.servicenum = data.service_count;
						that.formed.doneuser = data.consultation_log;

						this.doctitid = data.competent_id;
						this.doctitids = data.competent_ids;
						this.departid = data.department_id;
						this.departids = data.department_ids;

						this.formed.tw_mon = data.picture_consultation - 0;
						this.formed.yy_mon = data.voice_consultation - 0;
						this.formed.sp_mon = data.video_consultation - 0;

						that.formed.department = data.department_ids.split(",").map(Number); //科室id
						that.formed.doctitle = data.competent_ids.split(",").map(Number); //职称id
						that.formed.doctor_inquiry_url = data.doctor_inquiry_url
					})
					.catch((error) => {});

				that.formed.username = row.real_name; //申请人姓名
				that.formed.userId = row.identity_card; //身份证号
				that.formed.phone = row.phone; //手机号
				that.formed.hospital = row.hospital_id ? row.hospital_id : ""; //第一执业医院
				that.formed.new_hospital = row.hospital_id ? "" : row.new_hospital;



				that.dialog_info = true;
			},
			editSubmit(formName) {
				let that = this;
				that.$refs[formName].validate((valid) => {
					if (valid) {
						axios
							.post(
								"/admin/doctorAudit/editAudit", {
									id: that.eid,
									user_id: that.userid, // 账号id 登录信息里的id
									user_info_id: that.userinfoid, //基本信息id 登录信息里userinfo里的id
									real_name: that.formed.username, //申请人姓名
									identity_card: that.formed.userId, //身份证号
									phone: that.formed.phone, //手机号
									consultation_log: that.formed.doneuser - 0, //完成咨询人
									service_count: that.formed.servicenum, //服务数量
									praise: that.formed.goodnum, //好评率
									hospital_id: that.formed.hospital, //第一执业医院
									department_id: that.departid, //科室id
									department_ids: that.departids, // 所选科室第一级id拼接第二级id 入 32,33
									competent_id: that.doctitid, //职称id
									competent_ids: that.doctitids, //职称层级id 如1,2
									identity_card_pic: that.mapListed2, //身份证图片
									head_portrait_pic: that.mapListed, //头像图片
									physician_card_pic: that.mapListed3, //医师执业证书
									physician_seniority_pic: that.mapListed4, //医师资格证书
									competent_certificate_pic: that.mapListed5, //医师职称证书
									// examine: that.form.examine,
									// examine_result: that.form.result,
									good_at: that.formed.goodat, //擅长
									introduction: that.formed.brief, //介绍
									author: that.user.id,
									new_hospital: this.new_hospital,
									picture_consultation: that.formed.tw_mon,
									voice_consultation: that.formed.yy_mon,
									video_consultation: that.formed.sp_mon,
									source: this.source,
									doctor_inquiry_url: this.formed.doctor_inquiry_url
								}, {
									token: true,
								}
							)
							.then((response) => {
								if (response.data.code == "200") {
									that.dialog_info = false;
									that.search();
									that.$message({
										message: "操作成功",
										type: "success",
									});
								} else {
									that.$message.error(response.data.msg);
								}
							})
							.catch((error) => {});
					} else {
						that.$alert("信息遗漏未填");
						return false;
					}
				});
			},
			async exportExcel() {
				// var fix = document.querySelector('.el-table__fixed-right');
				let tabs = []
				let pages = Math.ceil(this.count / 15)
				this.dcing = true
				this.loading = true
				for (let i = 1; i <= pages; i++) {
					let res = await new Promise(ok => {
						axios
							.post("/admin/DoctorAudit/doctorDetailReport", {
								page: i,
								page_count: 15,
								province_code: '',
								city_code: '',
								start_time: '',
								end_time: '',
								hospital_id: '',
								competent_id: '',
								department_id: '',
								source: '',
								inviter_ids: ''
							}, {
								token: true
							})
							.then(ok)
							.catch(error => {})
					})
					tabs = tabs.concat(res.data.data.list)
				}
				if (tabs && tabs.length > 0) {
					this.dcing = false
					this.loading = false
					this.tableData2 = tabs
					this.$nextTick(() => {
						var xtable = document.querySelector('#out-table')
						this.$excels.exports(xtable, '医生明细')
					})
				}


			},
			handleSizeChange(val) {
				let that = this
				that.pagesize = val;
				that.search()
			},
			handleCurrentChange(val) {
				let that = this
				that.currentPage = val;
				that.search()
			},
		
			getall() {
				this.getks()
				this.getyqxx()
				this.all_sheng()
			},
		
		
			
			IterDelateChildren(arr) {
				for (let i = 0; i < arr.length; i++) {
					if (arr[i].children) {
						if (arr[i].children.length) {
							this.IterDelateChildren(arr[i].children)
						} else {
							delete arr[i].children
						}
					}
				}
				return arr
			},
		

			
			
		
			
		
		
		
			deleteHandle(t, row) {
				
			},
			handleSelectionChange(val) {
				this.selectusers = val;
			},
			getRowKeys(row) {
				return row.id; // id为列表数据的唯一标识
			},
			
		},
	};
</script>


<style lang="scss" scoped>
	.index {
		border-radius: 6px;
		padding-bottom: 10px;
	}

	.b_top {
		padding: 5px 0;
	}

	.el-dropdown-link {
		cursor: pointer;
		color: #5473E8;
		font-size: 12px;
	}
</style>